module.exports = {
    label: {
      headerTitle: 'Document Management',
      AddheaderTitle: 'Add Document Management',
      EditheaderTitle: 'Edit Document Management',
      companyName: 'Document Name',
      search: 'Search...',
      showPagination: {
        showing: 'Showing',
        to: 'to',
        of: 'of',
        entries: 'entries',
        rowsSelected: 'rows selected'
      },
      tooltips: {
        delete: 'Delete',
        edit: 'Edit'
      },
      buttons: {
        add: 'Add',
        save: 'Save',
        cancel: 'Cancel'
      }
    }
  }
  